import { render, staticRenderFns } from "./bindDiver.vue?vue&type=template&id=6c5847c5&scoped=true&"
import script from "./bindDiver.vue?vue&type=script&lang=js&"
export * from "./bindDiver.vue?vue&type=script&lang=js&"
import style0 from "./bindDiver.vue?vue&type=style&index=0&id=6c5847c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5847c5",
  null
  
)

export default component.exports